// locked - do not change values & mirror on server webhook
export const PAYMENT_JOB_POST_SERVICE = "job-post-service";
export const PAYMENT_COMPANY_LOGO_FEATURE_SERVICE =
  "company-promotion-featured-logo";
export const PAYMENT_COMPANY_PROFILE_SERVICE = "company-profile-service";
export const PAYMENT_SUBSCRIPTION_SERVICE = "subscription-plan";
export const ALL_SERVICES = "all-services";
